import {
    Outlet,
    Navigate,
    useLocation
} from "react-router-dom"
import styles from "./Main.module.css"

import { Navbar, Footer } from '@/components/layout'
import { useAuthStore } from '@/stores/useAuthStore'

import { ROUTES } from '@/constants/routes'

export function Main() {

    const location = useLocation()
    const isLogged = useAuthStore((s) => s.isLogged)

    if (location.pathname === "/") {
        return <Navigate to={isLogged ? ROUTES.home : ROUTES.login} replace />
    }

    return (
        <div className={styles.container}>
            <Navbar/>
            <div className={styles.contentWrapper}>
                <Outlet />
                <Footer />
            </div>
        </div>
    )
}
